//#region src/redux/posts/initial-state.ts
var initialState = {
	posts: [],
	isPending: false,
	isRejected: false,
	errorMessage: ""
};
//#endregion
export { initialState };

//# sourceMappingURL=initial-state.js.map